  import "./App.css";
import GoUp from "./components/GoUp";
import Header from "./components/Header";
import AboutCalpecoin from "./sections/AboutCalpecoin";
import GetStarted from "./sections/GetStarted";
import FAQ from "./sections/FAQ";
import Community from "./sections/Community";

function App() {

  return (
    <div className="App">
      <Header />
      <main>
        <AboutCalpecoin />
        <GetStarted />
        <FAQ />
        <section className="App-section">
          <h2>Beneficios para los ciudadanos de Calpe</h2>
          <p>Los usuarios que sean:</p>
          <ul>
            <li>Personas nacidas en Calpe</li>
            <li>Personas que viven o pasan parte del año en Calpe</li>
            <li>Personas que tienen familia en Calpe</li>
          </ul>
          <p>
            optarán a recibir 1000 CALP con la condición de utilizarlos para
            montar un masternode, con lo que podrán participar en Proof of
            Service y recibir recompoensas de bloque.
          </p>
        </section>
        <Community />
      </main>
      <GoUp />
    </div>
  );
}

export default App;
